module.exports = __webpack_public_path__ + "components/text-summaries/static/rusty-cc60cf4bf93042bcb7b45881b3785f38.jpg";